var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "figure",
    {
      staticClass: "cms-post-image",
      class: [
        "cms-post-image--" + _vm.mode,
        _vm.mode === "overlay"
          ? "cms-post-image--" + (_vm.textPosition || "bottom-left")
          : "",
      ],
      style: _vm.figureStyle,
    },
    [
      _c(
        "div",
        { staticClass: "cms-post-image__frame", style: _vm.frameStyle },
        [
          _vm.image.src
            ? _c(
                "img",
                _vm._b(
                  { staticClass: "cms-post-image__pic" },
                  "img",
                  _vm.picAttrs,
                  false
                )
              )
            : _c("div", { staticClass: "cms-post-image__empty" }, [
                _c("i", { staticClass: "fa fa-picture-o" }),
                _vm._v(" "),
                _c("span", [_vm._v("The post's featured picture shows here")]),
              ]),
          _vm._v(" "),
          _vm.mode === "overlay"
            ? _c("div", {
                staticClass: "cms-post-image__shade",
                style: { background: _vm.overlayColor || "rgba(0,0,0,0.45)" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "overlay"
            ? _c(
                "div",
                { staticClass: "cms-post-image__text" },
                [
                  _vm.isOn(_vm.showMeta)
                    ? _c("post-meta-block", {
                        staticClass: "cms-post-image__meta",
                        attrs: {
                          post: _vm.resolved,
                          "show-reading-time": false,
                          size: "normal",
                          align: _vm.overlayAlign,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticClass: "cms-post-image__title",
                      style: _vm.titleStyle,
                    },
                    [_vm._v(_vm._s(_vm.resolved.websitePostTitle))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.credit && _vm.mode === "overlay"
            ? _c(
                "small",
                {
                  staticClass:
                    "cms-post-image__credit cms-post-image__credit--inside",
                },
                [_vm._v(_vm._s(_vm.credit))]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.mode === "image" && (_vm.caption || _vm.credit)
        ? _c("figcaption", { staticClass: "cms-post-image__caption" }, [
            _vm.caption ? _c("span", [_vm._v(_vm._s(_vm.caption))]) : _vm._e(),
            _vm._v(" "),
            _vm.credit
              ? _c("small", { staticClass: "cms-post-image__credit" }, [
                  _vm._v(_vm._s(_vm.credit)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }